import { MultiSort } from 'src/app/components/dialogs/select-sort/select-sort.component';
import { BuiltInFieldsService } from '../../services/built-in-fields.service';
import { CustomCodingFieldsManager } from './custom-coding-fields-manager';
export class SortProcessor {
  constructor(
    private builtInFieldsService: BuiltInFieldsService,
    private ccfieldManager: CustomCodingFieldsManager
    ) { }

  public generateDisplayString(sort: MultiSort): string {
    const displayString: string[] = [];
    const directions = {
      'ASC': 'Ascending',
      'DESC': 'Descending'
    };
    if (sort.first.fieldId) displayString.push(`${this.getDisplayTitleById(sort.first.fieldId)} (${directions[sort.first.direction]})`);
    if (sort.second.fieldId) displayString.push(`${this.getDisplayTitleById(sort.second.fieldId)} (${directions[sort.second.direction]})`);
    if (sort.third.fieldId) displayString.push(`${this.getDisplayTitleById(sort.third.fieldId)} (${directions[sort.third.direction]})`);
    return displayString.join(', ');
  }

  public generateDatabaseString(sort: MultiSort): string {
    const dbString: string[] = [];
    if (sort.first.fieldId) dbString.push(`${sort.first.fieldId} ${sort.first.direction}`);
    if (sort.second.fieldId) dbString.push(`${sort.second.fieldId} ${sort.second.direction}`);
    if (sort.third.fieldId) dbString.push(`${sort.third.fieldId} ${sort.third.direction}`);
    return dbString.join(', ');
  }

  public getDisplayTitleById(id: string): string {
    const builtInField = this.builtInFieldsService.getField(id);
    if (builtInField)
      return builtInField.displayTitle;
      
    const codingField = this.ccfieldManager.getFieldById(id);
    if (codingField)
      return codingField.displayTitle;
    else
      return 'Not Found';
  }
}
